import { uc } from '@/api/login'
import { initialRoutes } from '@/router/routes'
import { useCinemaSettingStore } from '@/store/cinemaSetting'
import { isNilOrEmpty, isNotNilOrEmpty } from 'ramda-adjunct'
import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHashHistory(),
  routes: initialRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (from.path === to.path) {
      return
    }
    if (savedPosition != null) {
      return savedPosition
    }
    return { top: 0 }
  },
},
)
router.beforeEach(async (to) => {
  const profileStore = useProfileStore()
  const { profile } = storeToRefs(profileStore)
  // 一定要调用一下，见 useCinemaSettingStore
  const { cinemaSetting, updateCinemaSetting } = useCinemaSettingStore()

  // 跳到登陆页时判断是否已经登陆过
  if (to.name === 'Login') {
    if (!isNilOrEmpty(profile.value)) {
      return {
        name: 'ScanCode',
        replace: true,
      }
    }
    return
  }
  if (isNilOrEmpty(profile.value) || isNilOrEmpty(cinemaSetting)) {
    try {
      await uc()
      await updateCinemaSetting()
      if (to.name === 'Login') {
        return {
          name: 'ScanCode',
          replace: true,
        }
      }
    } catch (error) {
      console.error('error=>', error)
    }
  }

  // 权限检查
  const targetPermissions = to.meta?.permissions ?? []
  const shouldCheckPermission = isNotNilOrEmpty(targetPermissions)
  if (shouldCheckPermission) {
    const staffHasPermission = usePermission().checkPermission(targetPermissions)
    if (!staffHasPermission) {
      return {
        name: '403',
      }
    }
  }

  // [ZHONGXIN-INTERCEPTION] 拦截开关检查
  const requireInterceptionEnabled = to.meta?.requireInterceptionEnabled ?? false
  if (requireInterceptionEnabled) {
    const interceptEnabled = cinemaSetting?.interceptZhongxinApi ?? false
    if (!interceptEnabled) {
      // 拦截总开关未开启，重定向到首页或403页面
      return {
        name: 'ScanCode',
        replace: true,
      }
    }
  }
})

export default router
